import svgUrl from "ni:svgr;_2QSHTD1zzljSv13aQn2dyFWZy7umDm7lKBOVRbvWfs";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const SvgSend = props => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M7.826 1.71a1 1 0 0 1 1.223 0l4.063 3.142a1 1 0 1 1-1.224 1.582l-2.45-1.896V13.5a1 1 0 1 1-2 0V4.538L4.987 6.434a1 1 0 0 1-1.224-1.582l4.063-3.143Z" fill="currentColor" /></svg>;
const Memo = memo(SvgSend);
export { Memo as ReactComponent };